import React, { useEffect } from "react";

export function SmsTermsAndConditions() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="max-w-[44rem] mx-auto px-5 py-10 pb-16 font-sans text-[#1f2328] bg-white leading-relaxed">
      <h1 className="text-3xl font-bold text-[#1f2328] mb-1">
        SMS Terms &amp; Conditions
      </h1>
      <p className="text-sm text-[#5a6169] mb-8">
        Last updated: September 25, 2026 &middot; Netstratum Inc, 24 Takolusa Dr, Holmdel, NJ 07733
      </p>

      <h2 className="text-xl font-bold mt-8 mb-2 text-[#1f2328]">Program description</h2>
      <p className="mb-4 text-base">
        Netstratum Inc sends account-related SMS messages to its business customers. Messages include customer care communications to address inquiries and provide support, account notifications regarding order status and links to product rates, and two-factor authentication (2FA) messages for account security. All messaging is transactional and informational. We do not send marketing or promotional text messages.
      </p>

      <h2 className="text-xl font-bold mt-8 mb-2 text-[#1f2328]">How to opt in</h2>
      <p className="mb-3 text-base">
        You may opt in by completing the form at{" "}
        <a href="https://netstratum.com/sms-opt-in" className="text-[#0b5cab] hover:underline">
          https://netstratum.com/sms-opt-in
        </a>{" "}
        and checking the SMS consent box, or by texting the keyword <strong>SUBSCRIBE</strong> to{" "}
        <strong>+1 732-320-9170</strong>. The consent box is unchecked by default and is not a required field. Consent is not a condition of purchase.
      </p>
      <p className="mb-4 text-base">
        The consent language on the opt-in form reads: &quot;By checking this box, I consent to receive customer care, account notification, and two-factor authentication (2FA) SMS from Netstratum Inc. Reply STOP to opt-out; Reply HELP for support; Message &amp; data rates may apply; Messaging frequency may vary.&quot;
      </p>

      <h2 className="text-xl font-bold mt-8 mb-2 text-[#1f2328]">How to opt out</h2>
      <p className="mb-4 text-base">
        You may cancel at any time by replying <strong>STOP</strong> to any message you receive from us. You will receive one confirmation message and will then receive no further messages. You may also email{" "}
        <a href="mailto:support@netstratum.com" className="text-[#0b5cab] hover:underline">
          support@netstratum.com
        </a>{" "}
        or call +1 732-320-9170 to be removed.
      </p>

      <h2 className="text-xl font-bold mt-8 mb-2 text-[#1f2328]">Help</h2>
      <p className="mb-4 text-base">
        Reply <strong>HELP</strong> to any message, email{" "}
        <a href="mailto:support@netstratum.com" className="text-[#0b5cab] hover:underline">
          support@netstratum.com
        </a>
        , or call +1 732-320-9170.
      </p>

      <h2 className="text-xl font-bold mt-8 mb-2 text-[#1f2328]">Message frequency</h2>
      <p className="mb-4 text-base">Messaging frequency may vary based on account activity.</p>

      <h2 className="text-xl font-bold mt-8 mb-2 text-[#1f2328]">Cost</h2>
      <p className="mb-4 text-base">
        Message and data rates may apply. Charges are billed by, and payable to, your mobile service provider. Netstratum Inc does not charge for these messages.
      </p>

      <h2 className="text-xl font-bold mt-8 mb-2 text-[#1f2328]">Supported carriers</h2>
      <p className="mb-4 text-base">
        Carriers are not liable for delayed or undelivered messages. Message delivery is subject to effective transmission by your mobile service provider and is outside our control.
      </p>

      <h2 className="text-xl font-bold mt-8 mb-2 text-[#1f2328]">Eligibility</h2>
      <p className="mb-4 text-base">
        You must be at least 18 years old and the account holder or authorized user of the mobile telephone number you provide.
      </p>

      <h2 className="text-xl font-bold mt-8 mb-2 text-[#1f2328]">Privacy</h2>
      <p className="mb-4 text-base">
        Mobile opt-in information and your consent to receive SMS notifications will not be shared, sold, rented, or disclosed to any third party or affiliate for marketing or promotional purposes. See our{" "}
        <a href="https://netstratum.com/privacy-policy" className="text-[#0b5cab] hover:underline">
          Privacy Policy
        </a>{" "}
        for full details.
      </p>

      <h2 className="text-xl font-bold mt-8 mb-2 text-[#1f2328]">Changes to these terms</h2>
      <p className="mb-4 text-base">
        We may update these SMS Terms &amp; Conditions from time to time. Changes are effective when posted on this page, and the &quot;Last updated&quot; date above will be revised.
      </p>

      <h2 className="text-xl font-bold mt-8 mb-2 text-[#1f2328]">Contact</h2>
      <p className="text-base">
        Netstratum Inc<br />
        24 Takolusa Dr, Holmdel, NJ 07733<br />
        Email:{" "}
        <a href="mailto:support@netstratum.com" className="text-[#0b5cab] hover:underline">
          support@netstratum.com
        </a>
        <br />
        Phone: +1 732-320-9170
      </p>
    </div>
  );
}